import type { ProductRoadmapItem, RoadmapVoteReportItem } from '../../../types/ProductUpdates'

/**
 * Highest vote count wins; ties broken by stable title sort.
 */
export function pickTopVotedReportItem(items: RoadmapVoteReportItem[]): RoadmapVoteReportItem | null {
  const withVotes = items.filter((i) => i.voteCount > 0)
  if (withVotes.length === 0) return null
  return [...withVotes].sort((a, b) => {
    if (b.voteCount !== a.voteCount) return b.voteCount - a.voteCount
    return a.title.localeCompare(b.title)
  })[0]
}

/**
 * Clone a roadmap row for a follow-up item (e.g. after community voting). Clears voting attachment.
 */
export function duplicateRoadmapItemAsNew(
  source: ProductRoadmapItem,
  newId: string,
  options?: { titlePrefix?: string; status?: ProductRoadmapItem['status'] }
): ProductRoadmapItem {
  const prefix = options?.titlePrefix ?? ''
  return {
    id: newId,
    title: prefix ? `${prefix}${source.title}` : source.title,
    summary: source.summary,
    status: options?.status ?? 'planned',
    theme: source.theme,
    quarter: source.quarter,
    voteCampaignId: undefined,
  }
}
